const EnumType = Object.freeze({
    SINGLE_CHOICE: "SINGLE_CHOICE",
    SINGLE_CHOICE_OR_TEXT_FIELD: "SINGLE_CHOICE_OR_TEXT_FIELD",
    TEXT_FIELD: "TEXT_FIELD",
    DROPDOWN: "DROPDOWN",
    FULL_TEXT_FIELD : "FULL_TEXT_FIELD",
});


export default EnumType;